/* eslint-disable */ import { detailComponent, entityHeaderComponent, memoEval, sceneEntitySelectHotspotComponent, staticPerspectiveCameraComponent } from '@salsita-ai/platform-project-sdk/domain';
import { attachComponent } from '../implementation.js';
export const waistbandComponents = [
    attachComponent.withComponent(staticPerspectiveCameraComponent, 'default', true).withEntity('Waistband').withGradualFilter({
        selectedEntityIds: (self)=>self.id,
        viewStates: [
            'Default'
        ]
    }).attach(memoEval(()=>[], ()=>({
            priority: 2,
            fov: 35,
            near: 50,
            far: 2000,
            polarAngle: 1,
            minDistance: 300,
            maxDistance: 1000,
            lookAtY: 30,
            azimuthAngle: 0.5,
            distance: 400
        }))),
    attachComponent.withComponent(sceneEntitySelectHotspotComponent, 'select', true).withEntity('Waistband').attach(memoEval(()=>[], ()=>({
            azimuthAngleLimits: {
                min: -1.5,
                max: 1.5
            },
            polarAngleLimits: {
                min: 0.1,
                max: 3
            },
            title: 'Waistband',
            offsetZ: 111,
            offsetX: 0,
            offsetY: 88
        }))),
    attachComponent.withComponent(detailComponent, 'default', true).withEntity('Waistband').attach(memoEval(()=>[], ()=>({
            title: 'Waistband',
            subtitle: '',
            description: ''
        }))),
    attachComponent.withComponent(entityHeaderComponent, 'default', true).withEntity('Waistband').attach(memoEval(()=>[], ()=>({})))
];

//# sourceMappingURL=waistband.js.map